import axios from "axios";
import config from "../config/app.config";
import { setAuthorizationToken } from "../helpers/axios";

setAuthorizationToken();

const Apisetting = {
  Postlogin: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/login_admin`,
      data: data,
    };

    return await axios(resData);
  },
  Postlogin_verify: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/verify`,
      data: data,
    };

    return await axios(resData);
  },
  signUp: async (data) => {
    return await axios.post(`${config.apiURL}/api/v1/admin/signup`, data);
  },
  verifyOtp: async (data) => {
    return await axios.post(`${config.apiURL}/api/v1/admin/verify-otp`, data);
  },
  resendOtp: async (data) => {
    return await axios.post(`${config.apiURL}/api/v1/admin/resend-otp`, data);
  },
  forgotPassword: async (data) => {
    return await axios.post(
      `${config.apiURL}/api/v1/admin/forgot-password`,
      data
    );
  },
  logout: async () => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/logout`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return await axios(resData);
  },
  getdatanewss: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getdatanews`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data
    };
    return await axios(resData);
  },
  getAllBankAccount: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getAllBankAccounts`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return await axios(resData);
  },
  getDataBankAccounts: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/bank-accounts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data
    };

    return await axios(resData);
  },
  getSearchBankAccount: async (params) => {
    let { search, typeSearch } = params || {};
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getAllBankAccounts?search=${search}&typeSearch=${typeSearch}`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return await axios(resData);
  },
  getActiveBankAccount: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getAllBankAccounts?active=1`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return await axios(resData);
  },

  upBank_level_deposit: async (data) => {
    //console.log(data)
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/upBank_level_deposit`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },

  postHistory: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/auth/history`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  postAddbankAcc: async (data) => {
    //console.log(data)
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/create_BankAccountApiscb_Kbankz`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  postIsActiveBank: async (data) => {
    //console.log(data)
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/update_BankAccounts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  upBankAccountGroup: async (data) => {
    //console.log(data)
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/upBankAccountGroup`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getall_bankinfo: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getall_bankinfo`,
      headers: {
        "Content-Type": "application/json",
      },
      // data:data
    };

    return await axios(resData);
  },
  Cratepay: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/cratepay`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  Postupdate_settings: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v5/amb/postupdate_set`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  postupdate_all: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/sarubyod`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  datasetting: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/merchans/merchang_info`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return await axios(resData);
  },
  data_settingagent: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/data_settingagent`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return await axios(resData);
  },
  chack_logins: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/chack_logins`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return await axios(resData);
  },

  getEdit_setting: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/merchans/edit_setting`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },

  get_set_min_withdraw_deposit: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/edit_merchans`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  updateMerchantStatusAPI: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/edit_merchans`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  enabled_verify_hub: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/edit_merchans`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  postRemoveMerchantAPI: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/edit_merchans`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  Postchack_settings: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/chack_logins`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },

  Postupdate_settings_webfontend: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/Postupdate_settings_webfontend`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  setFees: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/editsetting_transaction_fee_settings`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
};
export default Apisetting;
